"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TileShapeEnum = void 0;
var TileShapeEnum;
(function (TileShapeEnum) {
    TileShapeEnum[TileShapeEnum["Wide"] = 0] = "Wide";
    TileShapeEnum[TileShapeEnum["WideSmall"] = 1] = "WideSmall";
    TileShapeEnum[TileShapeEnum["Card"] = 2] = "Card";
    TileShapeEnum[TileShapeEnum["CardBig"] = 3] = "CardBig";
})(TileShapeEnum || (exports.TileShapeEnum = TileShapeEnum = {}));
